/**
 * Re-export date-time types and constants from fe-common for use within ecomm-ssr.
 * Enables existing imports from ./date-time.constants to keep working.
 */
export type {
  DateFormatConfig,
  DateFormatName,
  DateFnsOverrideConfig,
  DateFormatOverrideConfig,
  DateFormatOverrides,
  FormattedDateResult,
  IntlOverrideConfig,
  UseFormattedDateOptions,
} from '@lastbrand/fe-common'
export {
  BASE_DATE_FORMATS,
  DATE_FORMAT_OVERRIDES,
  DATE_FNS_LOCALES,
  getDateFnsLocale,
  TIME_FORMATS,
} from '@lastbrand/fe-common'

import type { DateFormatOverrides } from '@lastbrand/fe-common'

/**
 * App-specific date format overrides for review items, store credits, and influencer IRL.
 * Pass as options.overrides when calling formatDate or useFormattedDate.
 */
export const STANDARD_DATE_OVERRIDES: Record<string, DateFormatOverrides> = {
  REVIEW_ITEM: {
    'en-ca': {
      NUMERIC_SLASH_DATE: {
        type: 'intl',
        locale: 'en-us',
      },
      SHORT_MONTH_DAY_YEAR: {
        type: 'intl',
        locale: 'en-us',
      },
    },
    'fr-ca': {
      NUMERIC_SLASH_DATE: {
        type: 'intl',
        locale: 'en-us',
      },
      SHORT_MONTH_DAY_YEAR: {
        type: 'intl',
        locale: 'en-us',
      },
    },
  },
  STORE_CREDITS: {
    'en-ca': {
      SHORT_MONTH_DAY_YEAR: {
        type: 'intl',
        locale: 'en-us',
      },
    },
    'fr-ca': {
      SHORT_MONTH_DAY_YEAR: {
        type: 'intl',
        locale: 'en-us',
      },
    },
  },
  INFLUENCER_IRL: {
    'en-us': {
      MONTH_SHORT_DAY_YEAR: {
        type: 'date-fns',
        formatString: 'PPP',
      },
    },
    'en-ca': {
      MONTH_SHORT_DAY_YEAR: {
        type: 'date-fns',
        formatString: 'PPP',
        locale: 'en-us',
      },
    },
    'fr-ca': {
      MONTH_SHORT_DAY_YEAR: {
        type: 'date-fns',
        formatString: 'PPP',
        locale: 'en-us',
      },
    },
  },
}
